<template>
  <v-avatar :class="{loading}" :height="calcHeight" :size="size" style="border-radius: 0;">
    <svg :class="{dark}" height="56.6929" viewBox="0 0 260.7874 56.6929" width="260.7874"
         xmlns="http://www.w3.org/2000/svg">
      <g id="Boundingbox">
        <rect fill="none" height="56.6929" width="260.7874"/>
      </g>
      <g id="Logo">
        <path
          class="fin-color-primary-light--fill"
          d="M64.2891,15.7441q-8.4695,0-12.5867,6.604V16.7542H44.9429V55.6016h6.7595V35.0125q0-6.5267,3.1079-9.6731a10.9543,10.9543,0,0,1,8.158-3.1468,9.476,9.476,0,0,1,7.07,2.6028q2.5638,2.6042,2.5637,7.3423V55.6016h6.76V31.7493q0-7.3806-4.1177-11.6931T64.2891,15.7441Z"/>
        <path
          class="fin-color-primary-light--fill"
          d="M12.9751,16.7542V15.5886q0-9.7114,10.2556-8.8571V.2051Q14.9942-.3376,10.6055,3.7014q-4.3909,4.04-4.39,11.8872v1.1656H0v6.5263H6.2156V55.6016h6.7595V23.2805H30.3008V55.6016H37.06V16.7542Z"/>
        <path
          class="fin-color-primary-light--fill"
          d="M260.7874,23.2805V16.7542H250.4539V5.8767l-6.76,2.02v8.8575H226.3687V15.5886q0-9.7114,10.2559-8.8571V.2051q-8.2365-.5427-12.6255,3.4963t-4.39,11.8872v1.1656h-6.2156v6.5263h6.2156V55.6016h6.76V23.2805h17.3257V44.3357q0,7.2256,4.1179,9.8286t12.9751,1.4373v-6.06q-3.42.1568-5.7495.1167a4.6283,4.6283,0,0,1-3.4573-1.2432q-1.1273-1.2037-1.1267-4.0791V23.2805Z"/>
        <path
          class="fin-color-primary-light--fill"
          d="M201.3792,23.4358q-5.0515-7.6918-14.6844-7.6917a18.638,18.638,0,0,0-13.9074,5.9436,20.0583,20.0583,0,0,0-5.75,14.49,20.0568,20.0568,0,0,0,5.75,14.49,18.638,18.638,0,0,0,13.9074,5.9436q9.6329,0,14.6844-7.6917v6.6817h6.76V16.7542h-6.76ZM197.4167,46.084a14.0716,14.0716,0,0,1-19.6569,0,13.5222,13.5222,0,0,1-3.9624-9.9063,13.5253,13.5253,0,0,1,3.9624-9.906,14.0716,14.0716,0,0,1,19.6569,0,13.5254,13.5254,0,0,1,3.9625,9.906A13.5222,13.5222,0,0,1,197.4167,46.084Z"/>
        <path
          class="fin-color-primary-light--fill"
          d="M153.5977,23.2805V16.7542h-6.7593V55.6016h6.7593V35.0125q0-6.37,3.5739-9.2459a12.25,12.25,0,0,1,8.5467-2.6416v-7.07Q156.9373,16.0547,153.5977,23.2805Z"/>
        <g>
          <path
            class="fin-color-accent-red--fill"
            d="M103.5906,46.6868l-3.5864,6.2116a28.2165,28.2165,0,0,0,14.1752,3.7945V49.5212A21.0775,21.0775,0,0,1,103.5906,46.6868Z"/>
          <path
            class="fin-color-primary-light--fill"
            d="M114.1794,49.5212v7.1717a28.3346,28.3346,0,0,0,24.5523-14.1714L132.52,38.9353A21.1663,21.1663,0,0,1,114.1794,49.5212Z"/>
          <path
            class="fin-color-primary-light--fill"
            d="M132.5205,17.7583l6.2114-3.5864A28.3337,28.3337,0,0,0,114.1794,0V7.1716A21.166,21.166,0,0,1,132.5205,17.7583Z"/>
          <path
            class="fin-color-primary-light--fill"
            d="M93.0046,28.3464a21.0764,21.0764,0,0,1,2.8343-10.5888l-6.2115-3.5865a28.3609,28.3609,0,0,0,10.3768,38.7273l3.5864-6.2116A21.1667,21.1667,0,0,1,93.0046,28.3464Z"/>
          <path
            class="fin-color-accent-green--fill"
            d="M114.1794,7.1716V0a28.3344,28.3344,0,0,0-24.552,14.1711l6.2115,3.5865A21.1661,21.1661,0,0,1,114.1794,7.1716Z"/>
        </g>
      </g>
    </svg>
  </v-avatar>
</template>

<script>
export default {
  name: 'finLogoFull',
  props: {
    /** Sets the height and width of the component. */
    size: {
      type: [Number, String],
      default: 170
    },
    /** Sets the dark mode. */
    dark: {
      type: Boolean,
      default: false
    },
    /** Sets the component to the loading state. */
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    calcHeight () {
      const w = 260; const h = 56
      const ratio = w / this.size
      const newHeight = h / ratio

      return newHeight + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
   @import "@/styles/main";

  .loading {
    animation: rotation 2s infinite alternate-reverse;
  }

  @keyframes rotation {
    from {
      transform: rotateX(0deg);
    }
    to {
      transform: rotateX(359deg);
    }
  }
</style>
